var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Simple editable MARC subfield input — inline layout.
 * Renders: $code  Label  [input field] on one row.
 */
import React, { useId } from 'react';
import { subfieldRowStyle, subfieldCodeStyle, subfieldLabelStyle, subfieldInputStyle, subfieldActionsStyle, subfieldReadOnlyInputStyle, subfieldInputBoxStyle, subfieldInputAdornedStyle, subfieldInputAdornmentStyle, } from './subfieldStyles';
import ClearFieldButton from './ClearFieldButton';
var rowStyle = subfieldRowStyle;
var codeStyle = subfieldCodeStyle;
var labelStyle = subfieldLabelStyle;
var inputStyle = subfieldInputStyle;
var inputErrorStyle = __assign(__assign({}, inputStyle), { borderColor: '#d0021b' });
var inputDisabledStyle = subfieldReadOnlyInputStyle;
var errorMsgStyle = {
    color: '#d0021b',
    fontSize: '12px',
    marginTop: '-4px',
    marginBottom: '8px',
    paddingLeft: '216px', // code width + label width + gaps
};
var SubfieldInput = function (_a) {
    var code = _a.code, label = _a.label, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, error = _a.error, required = _a.required, placeholder = _a.placeholder, disabled = _a.disabled, onClear = _a.onClear, registerProps = _a.registerProps, providedInputId = _a.inputId, inputAdornment = _a.inputAdornment;
    var generatedId = useId();
    var inputId = providedInputId !== null && providedInputId !== void 0 ? providedInputId : generatedId;
    var baseStyle = disabled ? inputDisabledStyle : (error ? inputErrorStyle : inputStyle);
    var input = (React.createElement("input", __assign({ id: inputId, type: "text", style: inputAdornment ? __assign(__assign({}, baseStyle), subfieldInputAdornedStyle) : baseStyle, value: value || '', onChange: onChange, onBlur: onBlur, placeholder: placeholder, disabled: disabled, "aria-required": required, "aria-invalid": !!error }, (registerProps || {}))));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: rowStyle },
            React.createElement("span", { style: codeStyle, "aria-hidden": "true" }, code ? "$".concat(code) : ''),
            React.createElement("label", { htmlFor: inputId, style: labelStyle },
                label,
                required && React.createElement("span", { style: { color: '#d0021b', marginLeft: '2px' }, "aria-hidden": "true" }, "*")),
            inputAdornment ? (React.createElement("span", { style: subfieldInputBoxStyle },
                input,
                React.createElement("span", { style: subfieldInputAdornmentStyle }, inputAdornment))) : input,
            React.createElement("span", { style: subfieldActionsStyle }, onClear && !disabled && (React.createElement(ClearFieldButton, { visible: !!value, onClear: onClear })))),
        error && React.createElement("div", { style: errorMsgStyle }, error)));
};
export default SubfieldInput;
